var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimsDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.571,
    height: 43.501,
    viewBox: "0 0 44.571 43.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3672",
    "data-name": "Rectangle 3672",
    width: 30.775,
    height: 33.699,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8227",
    "data-name": "Group 8227",
    transform: "translate(-90.462 -202.049)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3556",
    "data-name": "Rectangle 3556",
    width: 30,
    height: 30,
    transform: "translate(98.135 209.084)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8525",
    "data-name": "Group 8525",
    transform: "translate(104.849 243.818) rotate(-120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8524",
    "data-name": "Group 8524",
    transform: "translate(-2 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M7.72,1.734a12.59,12.59,0,0,1,12.064,9.583",
    transform: "translate(7.355 2.432)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    "data-name": "Path 4028",
    d: "M11.435,6.836l-6.216-2.9L10.839,0Z",
    transform: "translate(4.363 0.748)",
    fill: "#de1186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    d: "M12.235,23.223A12.589,12.589,0,0,1,.175,13.636",
    transform: "translate(3.461 6.31)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    d: "M8.611,19.123l6.216,2.9L9.2,25.959Z",
    transform: "translate(6.743 6.992)",
    fill: "#de1186"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u20B9",
    transform: "translate(108.135 229.084)",
    fill: "#de1186",
    fontSize: 18,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsDefaultIcon);
export default __webpack_public_path__ + "static/media/claims-default-icon.1401a857ceb6e81745ef30da9638d3db.svg";
export { ForwardRef as ReactComponent };